












import Vue from 'vue';
import DonutChart from '../../../common/Chart/DonutChart.vue';

export default Vue.extend({
  components: {
    DonutChart,
  },
  data(): {
    colors: string[];
  } {
    return {
      colors: ['#24BE99', '#FC5E54'],
    };
  },
  computed: {
    schemaAnalysis(): {
      정상: number;
      구문오류: number;
    } {
      const schemaAnalysisResult = this.$store.getters.schemaAnalysisResult;
      const badLabelNumber = schemaAnalysisResult.badLabelNumber;

      return {
        정상: schemaAnalysisResult.totalLabelNumber - badLabelNumber,
        구문오류: badLabelNumber,
      };
    },
    series(): number[] {
      return Object.values(this.schemaAnalysis);
    },
    labels(): string[] {
      return Object.keys(this.schemaAnalysis);
    },
  },
});
